import { render, staticRenderFns } from "./PopularUsers.vue?vue&type=template&id=2c0dfe21&"
import script from "./PopularUsers.vue?vue&type=script&lang=js&"
export * from "./PopularUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports